import { assertRssFeedFetchUrlAllowed } from './rssFeedUrlSafety'

/** User-Agent for upstream RSS fetches (some publishers block the Worker default). */
export const RSS_FEED_FETCH_USER_AGENT
  = 'Mozilla/5.0 (compatible; LucimarkFeeds/1.0; +https://feeds.lucimark.com)'

/** Per-upstream RSS fetch budget (admin freshness, feeds-api, test-fetch). */
export const RSS_FEED_FETCH_TIMEOUT_MS = 8_000

export function rssFeedFetchRequestInit(options?: { timeoutMs?: number }): RequestInit {
  const timeoutMs = options?.timeoutMs ?? RSS_FEED_FETCH_TIMEOUT_MS
  return {
    headers: {
      'Accept': 'application/rss+xml, application/xml, application/json, text/xml, */*',
      'User-Agent': RSS_FEED_FETCH_USER_AGENT
    },
    signal: AbortSignal.timeout(timeoutMs)
  }
}

const RSS_ARTICLE_HTML_MAX_BYTES = 512_000

/** Fetches a publisher article page for og:image enrichment (CNN Brasil and similar). */
export async function fetchRssArticleHtml(articleUrl: string): Promise<string | null> {
  try {
    assertRssFeedFetchUrlAllowed(articleUrl)
    const res = await fetch(articleUrl, {
      headers: {
        'Accept': 'text/html,application/xhtml+xml;q=0.9,*/*;q=0.8',
        'User-Agent': RSS_FEED_FETCH_USER_AGENT
      },
      signal: AbortSignal.timeout(RSS_FEED_FETCH_TIMEOUT_MS)
    })
    if (!res.ok) {
      return null
    }
    const text = await res.text()
    return text.length > RSS_ARTICLE_HTML_MAX_BYTES ? text.slice(0, RSS_ARTICLE_HTML_MAX_BYTES) : text
  }
  catch {
    return null
  }
}

export interface IRssDirectoryEntryPayloadLike {
  items?: readonly unknown[]
  upstreamError?: string
}

/** False when feeds-api returned no usable stories (upstream failure or empty pool). */
export function isRssDirectoryEntryPayloadUsable(payload: IRssDirectoryEntryPayloadLike): boolean {
  return !payload.upstreamError && (payload.items?.length ?? 0) > 0
}

export function rssDirectoryEntryLoadErrorMessage(payload: IRssDirectoryEntryPayloadLike): string | null {
  if (payload.upstreamError) {
    return payload.upstreamError
  }
  if ((payload.items?.length ?? 0) === 0) {
    return 'No RSS stories available'
  }
  return null
}
